<template>
  <div class="title">
    <span></span>
    <div v-html="title.title"></div>
  </div>
</template>

<script>
export default {
  props: ['title'],
  name: 'title-left',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title{
    color: var(--black-color);
    font-weight: 500;
    line-height: 1;
    font-size: 24px;
    position: relative;
    padding-left: 9px;
    margin-bottom: 20px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
  }
  .title::before{
    content: '';
    position: absolute;
    width: 4px;
    top:0;
    bottom: 0;
    left: 0;
    background-color: #248DDF;
    border-radius: 2px;
  }
  .title >>>span{
    color: #248DDF;
  }
  .screen3 .title{
    font-size: 15px;
    margin-bottom: 10px;
  }
  .screen3 .title::before{
    width: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/title.vue